import _objectSpread from "@babel/runtime/helpers/objectSpread2";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["children", "onlyFlex", "containerCols", "type", "as"];
import React, { forwardRef } from 'react';
import styled from 'styled-components';
import { isBreakpointKeyType, screens } from "../styles/breakpoints";
import { DASHBOARD_COLS, DESKTOP_COLS, getColsForPosition, getColsNum, getFlex, getGrid, getItemsPerRowFlex, getItemsPerRowGrid, MOBILE_COLS } from "./helpers";
import { jsx as _jsx } from "react/jsx-runtime";
var getContainerFlex = function getContainerFlex(theme, cols) {
  if (!cols && cols !== 0) {
    return '';
  }
  var styles = "\n    /** flex fallback for older browsers */\n    display: ".concat(getColsNum('xs', cols) > 0 ? 'flex' : 'none', ";\n    flex-flow: wrap;\n  ");
  Object.keys(screens).forEach(function (k, i) {
    var key = k;
    var colsNum = getColsNum(key, cols);
    if (colsNum >= 0 && (i === 0 ? colsNum !== getColsNum('xs', cols) : colsNum !== getColsNum(Object.keys(screens)[i - 1], cols))) {
      styles = styles.concat("\n        ".concat(theme.breakpoints.up(key), " {\n          display: ").concat(colsNum > 0 ? 'flex' : 'none', ";\n        }\n      "));
    }
  });
  return styles;
};
var getContainerGrid = function getContainerGrid(theme, containerCols, colsProp, position) {
  if (!colsProp && !position) {
    return '';
  }
  var cols = colsProp;
  if (!cols) {
    var contCols = {
      xs: getColsNum('xs', containerCols),
      sm: getColsNum('sm', containerCols),
      md: getColsNum('md', containerCols),
      lg: getColsNum('lg', containerCols)
    };
    var contColsXs = contCols.xs;
    var contColsSm = contCols.sm >= 0 ? contCols.sm : contColsXs;
    var contColsMd = contCols.md >= 0 ? contCols.md : contColsSm;
    var contColsLg = contCols.lg >= 0 ? contCols.lg : contColsMd;
    cols = {
      // @ts-ignore (deprecated component)
      xs: getColsForPosition(contColsXs, typeof position === 'string' ? position : position.xs) || 0,
      // @ts-ignore (deprecated component)
      sm: getColsForPosition(contColsSm, typeof position === 'string' ? position : position.sm, true) || 0,
      // @ts-ignore (deprecated component)
      md: getColsForPosition(contColsMd, typeof position === 'string' ? position : position.md, true),
      // @ts-ignore (deprecated component)
      lg: getColsForPosition(contColsLg, typeof position === 'string' ? position : position.lg, true)
    };
  }
  var styles = "\n    display: ".concat(getColsNum('xs', cols) > 0 ? '-ms-grid' : 'none', ";\n    display: ").concat(getColsNum('xs', cols) > 0 ? 'grid' : 'none', ";\n    -ms-grid-columns: repeat(").concat(getColsNum('xs', cols), ", 1fr);\n    grid-template-columns: repeat(").concat(getColsNum('xs', cols), ", 1fr);\n  ");
  Object.keys(screens).forEach(function (k, i) {
    var key = k;
    var colsNum = getColsNum(key, cols);
    if (colsNum >= 0 && (i === 0 ? colsNum !== getColsNum('xs', cols) : colsNum !== getColsNum(Object.keys(screens)[i - 1], cols))) {
      styles = styles.concat("\n        ".concat(theme.breakpoints.up(key), " {\n          display: ").concat(colsNum > 0 ? '-ms-grid' : 'none', ";\n          display: ").concat(colsNum > 0 ? 'grid' : 'none', ";\n          -ms-grid-columns: repeat(").concat(colsNum, ", 1fr);\n          grid-template-columns: repeat(").concat(colsNum, ", 1fr);\n        }\n      "));
    }
  });
  return styles;
};
var StyledItem = /*#__PURE__*/styled.div.withConfig({
  componentId: "sc-ni4kfw-0"
})(["\n  ", "\n  ", "\n"], function (_ref) {
  var isSubgrid = _ref.isSubgrid,
    theme = _ref.theme,
    cols = _ref.cols;
  return isSubgrid ? getContainerFlex(theme, cols) : '';
}, function (_ref2) {
  var theme = _ref2.theme,
    position = _ref2.position,
    posOffset = _ref2.posOffset,
    containerCols = _ref2.containerCols,
    cols = _ref2.cols,
    offset = _ref2.offset,
    customFallback = _ref2.customFallback;
  if (customFallback) {
    return customFallback;
  }
  var flexboxFallback = '';

  // eslint-disable-next-line no-nested-ternary
  var pos = position ? typeof position === 'string' ? position : position.xs : undefined;
  // eslint-disable-next-line no-nested-ternary
  var posOff = posOffset ? typeof posOffset === 'string' ? posOffset : posOffset.xs : undefined;
  if (pos) {
    flexboxFallback = flexboxFallback.concat(getItemsPerRowFlex(getColsNum('xs', containerCols), pos, posOff));
  } else if (cols) {
    flexboxFallback = flexboxFallback.concat(getFlex(getColsNum('xs', containerCols), getColsNum('xs', cols), offset ? getColsNum('xs', offset) : 0));
  }
  Object.keys(screens).forEach(function (k) {
    var key = k;
    // eslint-disable-next-line no-nested-ternary
    var bpPos = position ? key === 'sm' && typeof position === 'string' ? position : position[key] : undefined;
    // eslint-disable-next-line no-nested-ternary
    var bpPosOff = posOffset ? key === 'sm' && typeof posOffset === 'string' ? posOffset : posOffset[key] : undefined;
    if (isBreakpointKeyType(key)) {
      if (bpPos) {
        flexboxFallback = flexboxFallback.concat("\n            ".concat(theme.breakpoints.up(key), " {\n              ").concat(getItemsPerRowFlex(getColsNum(key, containerCols), bpPos, bpPosOff, true), "\n            }\n          "));
      } else if (cols && getColsNum(key, cols) >= 0) {
        flexboxFallback = flexboxFallback.concat("\n            ".concat(theme.breakpoints.up(key), " {\n              ").concat(getFlex(getColsNum(key, containerCols), getColsNum(key, cols), offset ? getColsNum(key, offset) : 0), "\n            }\n          "));
      }
    }
  });
  return flexboxFallback;
});
var StyledGridItem = /*#__PURE__*/styled(StyledItem).withConfig({
  componentId: "sc-ni4kfw-1"
})(["\n  @supports (display: grid) {\n    width: auto;\n    max-width: none;\n    margin-left: 0;\n    margin-right: 0;\n    ", "\n    ", "\n  }\n"], function (_ref3) {
  var theme = _ref3.theme,
    containerCols = _ref3.containerCols,
    cols = _ref3.cols,
    position = _ref3.position,
    isSubgrid = _ref3.isSubgrid;
  return isSubgrid ? getContainerGrid(theme, containerCols, cols, position) : '';
}, function (_ref4) {
  var theme = _ref4.theme,
    position = _ref4.position,
    containerCols = _ref4.containerCols,
    cols = _ref4.cols,
    startAt = _ref4.startAt;
  var gridStyles = '';
  // eslint-disable-next-line no-nested-ternary
  var pos = position ? typeof position === 'string' ? position : position.xs : undefined;
  if (pos) {
    gridStyles = gridStyles.concat(getItemsPerRowGrid(getColsNum('xs', containerCols), pos));
  } else if (cols) {
    var startAtCols = startAt ? getColsNum('xs', startAt) : 'auto';
    gridStyles = gridStyles.concat(getGrid(getColsNum('xs', cols), startAtCols > 0 ? startAtCols : 'auto'));
  }
  Object.keys(screens).forEach(function (k) {
    var key = k;
    // eslint-disable-next-line no-nested-ternary
    var bpPos = position ? key === 'sm' && typeof position === 'string' ? position : position[key] : undefined;
    if (isBreakpointKeyType(key)) {
      if (bpPos) {
        gridStyles = gridStyles.concat("\n              ".concat(theme.breakpoints.up(key), " {\n                ").concat(getItemsPerRowGrid(containerCols[key] ? containerCols[key] : getColsNum('sm', containerCols), bpPos, true), "\n              }\n            "));
      } else if (cols && getColsNum(key, cols) >= 0) {
        var _startAtCols = startAt ? getColsNum(key, startAt) : 'auto';
        gridStyles = gridStyles.concat("\n                ".concat(theme.breakpoints.up(key), " {\n                  ").concat(getGrid(getColsNum(key, cols), _startAtCols > 0 ? _startAtCols : 'auto'), "\n                }\n              "));
      }
    }
  });
  return gridStyles;
});
var Item = /*#__PURE__*/forwardRef(function (_ref5, ref) {
  var children = _ref5.children,
    onlyFlex = _ref5.onlyFlex,
    containerCols = _ref5.containerCols,
    _ref5$type = _ref5.type,
    type = _ref5$type === void 0 ? 'default' : _ref5$type,
    _ref5$as = _ref5.as,
    as = _ref5$as === void 0 ? 'div' : _ref5$as,
    other = _objectWithoutProperties(_ref5, _excluded);
  var cols = type === 'dashboard' ? DASHBOARD_COLS : {
    xs: MOBILE_COLS,
    sm: DESKTOP_COLS
  };
  var props = _objectSpread({
    as: as,
    containerCols: containerCols || cols,
    ref: ref
  }, other);
  if (onlyFlex) {
    return /*#__PURE__*/_jsx(StyledItem, _objectSpread(_objectSpread({
      onlyFlex: true
    }, props), {}, {
      children: children
    }));
  }
  return /*#__PURE__*/_jsx(StyledGridItem, _objectSpread(_objectSpread({}, props), {}, {
    children: children
  }));
});
Item.displayName = 'Item';
export default Item;